// Mock data for Pathways Africa website

export const navItems = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Foundation', href: '/foundation' },
  { label: 'Newsletter', href: '/newsletter' },
];

export const heroData = {
  title: 'PATHWAYS AFRICA',
  subtitle: 'FROM DREAM SCHOOLS TO DECISION LETTERS',
  description: 'A transformative college counseling and leadership development program designed to support high-achieving African students in their pursuit of world-class higher undergraduate education.',
};

export const aboutData = {
  title: 'About Pathways Africa',
  description: 'PATHWAYS AFRICA is a transformative college counseling and leadership development program designed to support high-achieving African students in their pursuit of world-class higher undergraduate education, particularly at Ivy League and other top-tier universities in the United States on full-ride (100%) scholarships.',
  mission: 'Rooted in a commitment to academic excellence, mentorship, and global citizenship, the program equips students with the tools, guidance, and exposure necessary to navigate the competitive college admissions process successfully.',
  stats: [
    { value: '50+', label: 'Students Supported' },
    { value: '100%', label: 'Full Ride Scholarship Commitment' },
    { value: '35+', label: 'Ivy League & Elite Schools' },
    { value: '$1.3M+', label: 'Scholarships Secured' },
  ],
};

export const foundationData = {
  title: 'START YOUR APPLICATION',
  subtitle: 'Pathways Africa Aided Fund (PAAF)',
  description: 'Our Premium College Counselling Program designed to guide high-achieving African students through the competitive college admissions process. This scholarship is intended for motivated students who have demonstrated academic excellence, leadership potential, and a clear drive to pursue higher education, but who may not have access to expert admissions support.',
  applicationNote: 'Please complete this application thoughtfully and honestly. Your responses will help us assess your background, aspirations, and readiness to benefit from the opportunities offered through Pathways Africa. All information submitted will be kept confidential and used solely for scholarship selection purposes.',
  features: [
    {
      title: 'College Application Support',
      description: 'Expert guidance through every step of the college application process, from selecting schools to crafting compelling essays.',
    },
    {
      title: 'SAT/ACT Preparation',
      description: 'Comprehensive test preparation resources and personalized study plans to help students achieve their best scores.',
    },
    {
      title: 'Scholarship Guidance',
      description: 'Strategic support in identifying and applying for full-ride scholarships at top universities worldwide.',
    },
    {
      title: 'Leadership Development',
      description: 'Programs designed to cultivate leadership skills and global citizenship among our scholars.',
    },
  ],
};

export const faqData = [
  {
    question: 'Does Pathways Africa journey with scholars to the end of the college application season?',
    answer: 'Yes. Pathways Africa is committed by its founding values to give its scholars guidance to the decision days. The program, by contractual agreement, runs for three to four months, however, the engagement between the scholars and the organization is sustained to the opening of their letters.',
  },
  {
    question: 'Does Pathways Africa give scholarships for students to take their undergraduate studies abroad?',
    answer: 'No. Pathways Africa is a college counselling body that focuses on coaching scholars through the college application process with the aim of getting into prestigious universities with full-ride (100%) scholarships.',
  },
  {
    question: 'Do PA scholars have to do the SAT?',
    answer: 'Yes. As from Pathways Africa (PA) previous cohort, PA 24-25, there has been addition of the SAT requirement for PA 25-26 and all cohorts following it due to the reinstated requirement of SAT by most USA universities for the 2025-2026 application cycle.',
  },
  {
    question: 'Is Pathways Africa a charity organization?',
    answer: 'No. While Pathways Africa has the goal of making the program free of charge and as affordable as possible to its shortlisted scholars it currently remains a fee-serviced program and only students under the PAAF have a special arrangement.',
  },
  {
    question: 'Are scholars of Pathways Africa of only a particular region?',
    answer: 'Pathways Africa has the long-term objective of spreading to all African regions but is currently centred in East, Central Africa and Southern Africa.',
  },
  {
    question: 'Is Pathways Africa only focused on universities in the USA and UK?',
    answer: 'No. While Pathways Africa is majorly focused on the US and UK region it also supports its scholars to send multiple applications to other universities in different nations where a full-ride scholarships can be secured. This is alongside their main applications to US universities.',
  },
];

export const socialLinks = [
  { name: 'Instagram', url: 'https://www.instagram.com/pathways.africa?igsh=MW15bXpja3llMXM5Zg==', icon: 'instagram' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/company/pathwaysafrica/', icon: 'linkedin' },
  { name: 'WhatsApp', url: 'https://wa.me/254795646194', icon: 'whatsapp' },
  { name: 'Eventbrite', url: 'https://www.eventbrite.com/e/path-to-top-usa-and-uk-universities-and-colleges-tickets-1981587263849?aff=ebdsshcopyurl&utm-campaign=social&utm-content=attendeeshare&utm-medium=discovery&utm-term=organizer-profile&utm-share-source=organizer-profile', icon: 'eventbrite' },
];

export const footerLinks = {
  quickLinks: [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Foundation', href: '/foundation' },
    { label: 'Newsletter', href: '/newsletter' },
  ],
  programs: [
    { label: 'College Counseling', href: '#' },
    { label: 'SAT Preparation', href: '#' },
    { label: 'Scholarship Support', href: '#' },
    { label: 'Leadership Training', href: '#' },
  ],
  resources: [
    { label: 'Application Guide', href: '#' },
    { label: 'Student Stories', href: '#' },
    { label: 'FAQs', href: '/faq' },
  ],
};

export const contactInfo = {
  email: 'Admissions@pathwaysafrica.group',
  phones: [
    { label: 'Kenyan Line', number: '+254795646194' },
    { label: 'US Line', number: '+1-2155949637' },
  ],
};

// Floating elements data for interactivity
export const floatingElements = [
  { icon: 'graduation', label: 'Harvard', delay: 0 },
  { icon: 'building', label: 'Stanford', delay: 0.5 },
  { icon: 'award', label: 'MIT', delay: 1 },
  { icon: 'book', label: 'Yale', delay: 1.5 },
  { icon: 'star', label: 'Princeton', delay: 2 },
];
